module.exports = true;



// WEBPACK FOOTER //
// ../node_modules/core-js/library/modules/_library.js